module.exports = __webpack_public_path__ + "img/aspect-ratio.64015e15.svg";